import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Button, Typography } from "@platform/design-system";

import type { JSX } from "react";

interface Props {
  isOpen: boolean;
  onClose: VoidFunction;
  coverageName: string;
  groupNumber: string;
}

const PolicyNotFoundDialog = ({
  isOpen,
  onClose,
  coverageName,
  groupNumber,
}: Props): JSX.Element => (
  <Dialog
    open={isOpen}
    onClose={onClose}
    aria-labelledby="confirm-dialog-title"
    aria-describedby="confirm-dialog-description"
    maxWidth="sm"
  >
    <DialogTitle id="policy-not-found-title">{`${coverageName} Policy Not Found`}</DialogTitle>
    <DialogContent>
      <>
        <Typography mb={3}>
          We&apos;re having trouble finding that policy. Please confirm that the
          below group number matches exactly what the carrier provided:
        </Typography>
        <Typography mb={3}>
          Provided Group Number:{" "}
          <Typography component="span">
            <strong>{groupNumber}</strong>
          </Typography>
        </Typography>
        <Typography mb={3}>
          Please reach out to{" "}
          <Typography component="span" className="with-underline">
            team@centrobenefits.com
          </Typography>{" "}
          to have the group number corrected, or for assistance if you still
          can&apos;t access the policy data.
        </Typography>
      </>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default PolicyNotFoundDialog;
